import React from "react";
import { Container, Row } from "react-bootstrap";
import SkillBars from "./SkillBars";
import SectionTitle from "../SectionTitle";

function Skills() {
  return (
    <Container fluid className="about-section">
      <Container>
        <Row className="home-about-description">
          <SectionTitle index="02" title="Compétences" />
        </Row>
        <SkillBars />
      </Container>
    </Container>
  );
}

export default Skills;
